<template>
  <div class="EmergencyDriverCalculationForm">
    <form @submit="onCalculate">
      <text-field
        :value="ledArrayVoltage"
        type="number"
        label="LED Array Voltage [V]"
        step="0.1"
        @input="onLedArrayVoltageChange"
        :tooltipContent="'Voltage across load'"
      >
      </text-field>
      <text-field
        :value="maxDriverOutput"
        label="Max driver output [mA]"
        type="number"
        @input="onMaxDriverOutputChange"
        :tooltipContent="'Maximum possible driver output current in mA'"
      >
      </text-field>
      <text-field
        :value="maxLedPower"
        label="Max LED power [W]"
        type="number"
        @input="onMaxLedPowerChange"
        :tooltipContent="'Maximum allowable LED array power in W'"
      >
      </text-field>
      <div class="form-radio mt-3">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="emergencyDriverFlux"
            v-model="inputLockModel"
            id="emergencyDriverFlux"
            name="emergency-driver-input-radio"
          />
          <label class="custom-control-label" for="emergencyDriverFlux">
            <text-field
              :value="emergencyDriverFlux"
              class="mb-2"
              type="number"
              label="EM flux [lm]"
              @input="onEmergencyDriverFluxChange"
              :tooltipContent="
                'If you select this bullet point the value remains fixed after you change the lm/w value or the (W) value'
              "
            >
            </text-field>
          </label>
        </div>
      </div>

      <div class="form-radio">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="emergencyDriverEfficacy"
            v-model="inputLockModel"
            id="emergencyDriverEfficacy"
            name="emergency-driver-input-radio"
          />
          <label class="custom-control-label" for="emergencyDriverEfficacy">
            <text-field
              :value="emergencyDriverFlux"
              class="mb-2"
              type="number"
              label="EM efficacy [lm/W]"
              @input="onEmergencyDriverEfficacyChange"
              :tooltipContent="
                'If you select this bullet point the value remains fixed after you change the Lumens value or the (W) value'
              "
            >
            </text-field>
          </label>
        </div>
      </div>

      <div class="form-radio">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="emergencyDriverPower"
            v-model="inputLockModel"
            id="emergencyDriverPower"
            name="driver-input-radio"
          />
          <label class="custom-control-label" for="emergencyDriverPower">
            <text-field
              :value="emergencyDriverPower"
              class="mb-2"
              type="number"
              label="EM Power [W]"
              @input="onEmergencyDriverPowerChange"
              :tooltipContent="
                'Filter the results list to a power within +/- 15% of the entered value'
              "
            ></text-field>
          </label>
        </div>
      </div>

      <div @click="clearValues" class="clear pb-4 pt-2">
        Clear values
      </div>
      <button type="submit" class="btn btn-secondary btn-block btn-sm">
        Calculate
      </button>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { EventBus } from "@/eventbus";

export default {
  name: "EmergencyDriverCalculationForm",
  data: () => {
    return {
      inputLockModel: false,
      ranges: {
        voltage: {
          min: null,
          max: null
        },
        power: {
          min: null,
          max: null
        }
      }
    };
  },
  computed: {
    ...mapState("brain", ["region"]),
    ...mapState("brain/emergencyDrivers", ["inputLock", "emergencyDrivers"]),

    ...mapGetters("brain/emergencyDrivers", [
      "ledArrayVoltage",
      "maxDriverOutput",
      "maxLedPower",
      "emergencyDriverFlux",
      "emergencyDriverEfficacy",
      "emergencyDriverPower"
    ]),
    ...mapGetters("brain/solutions", ["hasSolutions", "solution"])
  },
  methods: {
    onLedArrayVoltageChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setLedArrayVoltage",
        value.target.value
      );
    },
    onMaxDriverOutputChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setMaxDriverOutput",
        value.target.value
      );
    },
    onMaxLedPowerChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setMaxLedPower",
        value.target.value
      );
    },
    onEmergencyDriverFluxChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setEmergencyDriverFlux",
        value.target.value
      );
      this.onLumensCalculationChange("emergencyDriverFlux");
    },
    onEmergencyDriverEfficacyChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setEmergencyDriverEfficacy",
        value.target.value
      );
      this.onLumensCalculationChange("emergencyDriverEfficacy");
    },
    onEmergencyDriverPowerChange(value) {
      this.$store.commit(
        "brain/emergencyDrivers/setEmergencyDriverPower",
        value.target.value
      );
      this.onLumensCalculationChange("emergencyDriverPower");
    },

    onCalculate(event) {
      if (event) {
        event.preventDefault();
      }
      EventBus.$emit("handleFilterChange", {});
    },
    clearValues() {
      this.$store.commit("brain/emergencyDrivers/clearCalculatedPerformance");
    },
    onLumensCalculationChange(changed) {
      console.log("lock:", this.inputLock);
      console.log("change:", changed);
      switch (this.inputLock) {
        case "emergencyDriverFlux":
          if (
            changed === "emergencyDriverEfficacy" &&
            this.emergencyDriverFlux !== "" &&
            this.emergencyDriverEfficacy !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverPower",
              Math.round(
                (this.emergencyDriverFlux / this.emergencyDriverEfficacy) * 10
              ) / 10
            );
          } else if (
            changed === "emergencyDriverPower" &&
            this.emergencyDriverFlux !== "" &&
            this.emergencyDriverPower !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverEfficacy",
              Math.round(this.emergencyDriverFlux / this.emergencyDriverPower)
            );
          }
          break;
        case "emergencyDriverEfficacy":
          if (
            changed === "emergencyDriverFlux" &&
            this.emergencyDriverFlux !== "" &&
            this.emergencyDriverEfficacy !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverPower",
              Math.round(
                (this.emergencyDriverFlux / this.emergencyDriverEfficacy) * 10
              ) / 10
            );
          } else if (
            changed === "emergencyDriverPower" &&
            this.emergencyDriverEfficacy !== "" &&
            this.emergencyDriverPower !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverFlux",
              Math.round(
                this.emergencyDriverEfficacy * this.emergencyDriverPower
              )
            );
          }
          break;
        case "emergencyDriverPower":
          if (
            changed === "emergencyDriverFlux" &&
            this.emergencyDriverFlux !== "" &&
            this.emergencyDriverPower !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverEfficacy",
              Math.round(this.emergencyDriverFlux / this.emergencyDriverPower)
            );
          } else if (
            changed === "emergencyDriverEfficacy" &&
            this.emergencyDriverEfficacy !== "" &&
            this.emergencyDriverPower !== ""
          ) {
            this.$store.commit(
              "brain/emergencyDrivers/setEmergencyDriverFlux",
              Math.round(
                this.emergencyDriverEfficacy * this.emergencyDriverPower
              )
            );
          }
          break;
      }
    },
    updateRanges() {
      if (this.emergencyDrivers.length) {
        this.ranges.voltage.max = this.emergencyDrivers.reduce(
          (prev, current) => {
            return prev.ovMax > current.ovMax ? prev : current;
          }
        ).ovMax;
        this.ranges.voltage.min = this.emergencyDrivers.reduce(
          (prev, current) => {
            return prev.ovMin < current.ovMin ? prev : current;
          }
        ).ovMin;

        this.ranges.power.max = this.emergencyDrivers.reduce(
          (prev, current) => {
            return prev.opMax > current.opMax ? prev : current;
          }
        ).opMax;
        this.ranges.power.min = this.emergencyDrivers.reduce(
          (prev, current) => {
            return prev.opMin < current.opMin ? prev : current;
          }
        ).opMin;
      }
    },
    getOutputVoltage(driver) {
      if (driver.driverCalculationResult.outputVoltage != null) {
        return (
          Math.round(driver.driverCalculationResult.outputVoltage * 10) / 10
        );
      }
      return null;
    }
  },
  created() {
    this.inputLockModel = this.inputLock;

    if (this.hasSolutions && this.solution.driver) {
      let ledArrayVoltage = this.getOutputVoltage(this.solution.driver);
      if (ledArrayVoltage !== null) {
        this.$store.commit(
          "brain/emergencyDrivers/setLedArrayVoltage",
          ledArrayVoltage
        );
      }

      let maxLedPower = this.$store.getters["brain/drivers/driverPower"];
      if (maxLedPower !== null) {
        this.$store.commit(
          "brain/emergencyDrivers/setMaxLedPower",
          maxLedPower
        );
      }
      if (this.$store.getters["brain/drivers/driver"] !== null) {
        let maxDriverOutput =
          this.$store.getters["brain/drivers/driver"].ocMax * 1000;
        if (maxDriverOutput !== null) {
          this.$store.commit(
            "brain/emergencyDrivers/setMaxDriverOutput",
            maxDriverOutput
          );
        }
      }

      this.onCalculate();
    }
  },
  watch: {
    inputLock() {
      this.inputLockModel = this.inputLock;
    },
    inputLockModel: function(inputLock) {
      this.$store.commit("brain/emergencyDrivers/setInputLock", inputLock);
    },
    emergencyDrivers() {
      this.updateRanges();
    }
  }
};
</script>

<style lang="scss" scoped>
.EmergencyDriverCalculationForm {
  padding: 0 1.5rem;
}
.custom-control-label {
  margin: 0;
}

.custom-control-label:after,
.custom-control-label:before {
  top: 0.15625rem;
  width: 1rem;
  height: 1rem;
}

.formGroupInput {
  border: 1px solid $mid-gray-600;
  &::placeholder {
    color: $mid-gray-600;
  }
}
.formGroupInputRadio {
  border: 1px solid $mid-gray-600;
  &::placeholder {
    color: $mid-gray-600;
  }
}

.form-text {
  color: $blue;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-secondary,
.btn-outline-secondary {
  font-size: 1.1rem;
  font-weight: normal;
  cursor: pointer;
}

.range {
  font-size: 11px;
}

.custom-control-input,
.custom-control-label {
  cursor: pointer;
}

.clear {
  align-self: flex-end;
  color: $blue;
  text-decoration: underline;
  cursor: pointer;
}

.pb-4 {
  padding-bottom: 0 !important;
  margin-bottom: 15px !important;
}
</style>

<style lang="scss">
.EmergencyDriverCalculationForm {
  .easy-tooltip {
    margin: 0 2px;
    float: right;
  }
}
</style>
